import { Component, OnInit, Input } from '@angular/core';
import { ModalController} from '@ionic/angular';

@Component({
  selector: 'app-contacts-import-view',
  templateUrl: './contacts-import-view.page.html',
  styleUrls: ['./contacts-import-view.page.scss'],
})
export class ContactsImportViewPage implements OnInit {

  @Input() public contactToView: any;

  constructor(public modalCtrl: ModalController) { 
    console.log('constructor');
  }

  ngOnInit() {
    console.log('Hi from contact import view page');
    console.log(this.contactToView);
  }

  dismiss() {  
    this.modalCtrl.dismiss();  
  }

  async importContact() {
    this.modalCtrl.dismiss(this.contactToView);
  }

  submitForm() {
  }

}
